import { yupObject, validation } from 'utils/validation';

const { name, email } = validation.inviteDesigner;

export const validationSchema = yupObject({
  name,
  email,
});
